import { useState, useEffect } from 'react'
import { Swiper, SwiperSlide } from "swiper/react";

import { BookCard } from '../BookCard/BookCard';
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import CarouselSlider from "../../hooks/swipperEffect";
import "swiper/scss";
import "swiper/scss/autoplay";
import "swiper/scss/pagination";
import "swiper/scss/navigation";
import "swiper/scss/virtual";
import "./bookSwiper.scss";
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom';
import ModalLibroHome from '../modalLibro/ModalLibroHome';
import ModalLibro from '../modalLibro/ModalLibro';

const rut = "https://www.ricardosalinas.com/images/libros/"

const BookSwiper = (props) => {

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [spaceBetween, setSpaceBetween] = useState(isMobile ? 30 : 70);
  const navigate = useNavigate();
  const [t, i18n] = useTranslation("home");
	const liga_lang1='/'+i18n.language+"/biblioteca";
  const [t2, i18n2] = useTranslation("biblioteca");

  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [variable1, setVariable1] = useState("");
  const [variable2, setVariable2] = useState("");
  const [variable3, setVariable3] = useState("");
  const [variable4, setVariable4] = useState("");
  const [variable5, setVariable5] = useState("");
  const [variable6, setVariable6] = useState("");
  const [variable7, setVariable7] = useState("");
  const [variable8, setVariable8] = useState("");
  const [variable9, setVariable9] = useState("");

  const openModal2 = (
    value1,
    value2,
    value3,
    value4,
    value5,
    value6,
    value7,
    value8,
    value9
  ) => {

    setVariable1(value1);
    setVariable2(value2);
    setVariable3(value3);
    setVariable4(value4);
    setVariable5(value5);
    setVariable6(value6);
    setVariable7(value7);
    setVariable8(value8);
    setVariable9(value9);
    setIsModalOpen2(true);
  };

  const formatDate = (date) => {
    const options = { year: "numeric" };
    return new Date(date).toLocaleDateString(i18n.language, options);
  };

  const closeModal2 = () => {
    setIsModalOpen2(false);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      setSpaceBetween(window.innerWidth < 768 ? 10 : 70);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // const openModal = () => {
  //   setIsModalOpen2(true);
  // }

  // const closeModal = () => {
  //   setIsModalOpen2(false);
  // }

  // imagen
  // titulo
  // descripcion
  // autor
  // editorial
  // fecha
  // publicado


  return (
    <>
      <Swiper
        className="books-swiper"
        modules={[Autoplay, Navigation, Pagination, CarouselSlider ]}
        effect="carousel"
        grabCursor={true}
        spaceBetween={spaceBetween}
        loop={true}
        pagination={{
          el: ".swiper-pagination",
        }}
        slidesPerView={"auto"}
        >
        {props.items.map((book, index) => {
          return(
          <SwiperSlide key={index}>
            {({isActive})=> 
            <BookCard books={book} key={index} index={index} isActive={isActive}
            {...book}
            onClick={() => {
              openModal2(
                rut + book.imagen,
                book.imagen.substring(0, book.imagen.length - 4),
                book.titulo,
                book.descripcion,
                book.autor,
                book.editorial,
                formatDate(book.fecha),
                book.blog,
                i18n2.language)
              }}
            />
            }
          </SwiperSlide>
        )})}
      </Swiper>

      <ModalLibroHome isOpen={isModalOpen2} closeModal={closeModal2} variable1={variable1} variable2={variable2} variable3={variable3} variable4={variable4} variable5={variable5} variable6={variable6} variable7={variable7} variable8={variable8} variable9={variable9} />

      {/* <ModalLibroHome isOpen={openModal} closeModal={closeModal} /> */}
    </>
  )
}

export default BookSwiper
